(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nova-product-highlight"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.nvh').forEach(function (root) {
    var media = root.querySelector('[data-nvh-media]');
    var vid = media && media.querySelector('.nvh__video');
    var dlg = root.querySelector('[data-nvh-dialog]');
    var dvid = dlg && dlg.querySelector('.nvh__d-video');
    var hoverable = window.matchMedia('(hover: hover)').matches;
    if (vid && media && hoverable) {
      media.addEventListener('mouseenter', function () { vid.play().then(function(){ media.classList.add('is-playing'); }).catch(function(){}); });
      media.addEventListener('mouseleave', function () { vid.pause(); media.classList.remove('is-playing'); });
    }
    function open () {
      if (!dlg) return;
      if (vid) { vid.pause(); media.classList.remove('is-playing'); }
      dlg.showModal(); document.documentElement.style.overflow = 'hidden';
      if (dvid) { dvid.currentTime = 0; dvid.play().catch(function(){}); }
    }
    function close () { if (!dlg) return; if (dvid) dvid.pause(); dlg.close(); document.documentElement.style.overflow = ''; }
    root.querySelectorAll('[data-nvh-open]').forEach(function (b) { b.addEventListener('click', open); });
    root.querySelectorAll('[data-nvh-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (dlg) {
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { if (dvid) dvid.pause(); document.documentElement.style.overflow = ''; });
    }
    if (location.hash === '#' + root.id) open();
  });
  } catch(e) { console.error(e); }
})();

})();
